import React, { lazy } from "react";
import queryString from "query-string";
import PrivateRoute from "PrivateRoutes";
const KnowledgeBaseDoc = lazy(() =>
  import(/* webpackChunkName: "KnowledgeBaseDoc" */ "./components")
);
const KnowledgeBaseDocAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "KnowledgeBaseDocAddEdit" */ "./components/KnowledgeBaseDocAddEdit"
  )
);
const KnowledgeBaseList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  console.log("queryParams", queryParams);
  return <KnowledgeBaseDoc kBaseId={queryParams.id} />;
};

const createForm = ({ location, match }) => {
  const kBaseId = match.params.kBaseId;
  const responseData = location.state ? location.state.responseData : null;
  return (
    <KnowledgeBaseDocAddEdit
      mode="create"
      kBaseId={kBaseId}
      responseData={responseData}
    />
  );
};

const testingForm = ({ location, match }) => {
  const kBaseId = match.params.kBaseId;
  const responseData = location.state ? location.state.responseData : null;
  return (
    <KnowledgeBaseDocAddEdit
      mode="testingForm"
      kBaseId={kBaseId}
      responseData={responseData}
    />
  );
};

const settingsForm = ({ location, match }) => {
  const kBaseId = match.params.kBaseId;
  const responseData = location.state ? location.state.responseData : null;
  return (
    <KnowledgeBaseDocAddEdit
      mode="settingsForm"
      kBaseId={kBaseId}
      responseData={responseData}
    />
  );
};

const editForm = ({ match }) => {
  const kBaseId = match.params.kBaseId;
  const kBaseDocId = match.params._id;
  return (
    <KnowledgeBaseDocAddEdit
      mode="edit"
      kBaseId={kBaseId}
      kBaseDocId={kBaseDocId}
    />
  );
};

const routes = () => (
  <React.Fragment>
    <PrivateRoute
      exact
      path="/settings/knowledge-base-doc"
      component={KnowledgeBaseList}
    />

    <PrivateRoute
      key="/settings/knowledge-base-doc/:kBaseId/create"
      exact={true}
      path="/settings/knowledge-base-doc/:kBaseId/create"
      component={createForm}
    />

    <PrivateRoute
      key="/settings/knowledge-base-doc/:kBaseId/hitTesting"
      exact={true}
      path="/settings/knowledge-base-doc/:kBaseId/hitTesting"
      component={testingForm}
    />

    <PrivateRoute
      key="/settings/knowledge-base-doc/:kBaseId/settings"
      exact={true}
      path="/settings/knowledge-base-doc/:kBaseId/settings"
      component={settingsForm}
    />

    <PrivateRoute
      key="/settings/knowledge-base-doc/:kBaseId/edit/:_id"
      exact={true}
      path="/settings/knowledge-base-doc/:kBaseId/edit/:_id"
      component={editForm}
    />
  </React.Fragment>
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/KnowledgeBaseDoc/routes.js